function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "hsla(0,0%,82%,1)",
  cx: 5.5,
  cy: 6.5,
  r: 5.5
}), React.createElement("text", {
  fontFamily: "Overpass-Bold, Overpass",
  fontSize: 10,
  fontWeight: "bold",
  letterSpacing: .3125,
  fill: "#FFF"
}, React.createElement("tspan", {
  x: 3,
  y: 10
}, "?")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 11
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/QuestionMarkSmall.33ee9143.svg";
export { SvgComponent as ReactComponent };